<template>
  <div>
    <lf-dropdown
      :name="name"
      :value="priorityLevel"
      :options="priorityLevels"
      menu-width="w-28"
      :disabled="disabled"
      :teleport-options="teleportOptions"
      :custom-z-index="customZIndex"
      @change="$emit('change', $event as TaskPriorityLevels)"
    >
      <template #toggle-button="{ toggle, value, menuOpen }">
        <div
          class="toggle-button flex items-center justify-center space-x-1 rounded-2xl border bg-white px-3 h-7 uppercase"
          :class="
            disabled
              ? 'pointer-events-none items-center'
              : 'cursor-pointer justify-between'
          "
          @click="toggle"
        >
          <div class="flex items-center space-x-1">
            <icon-base
              height="15"
              width="15"
              view-box="0 0 15 15"
              :class="
                prioritiesIconsMap[value as keyof typeof prioritiesIconsMap]
                  .class
              "
              :icon="
                prioritiesIconsMap[value as keyof typeof prioritiesIconsMap]
                  .icon
              "
            />
            <span v-if="showValue" class="font-semibold capitalize">
              {{ value }}
            </span>
          </div>
          <icon-base
            v-if="!disabled"
            height="6"
            width="10"
            icon="dropdown-arrow"
            :class="{ 'rotate-180 transform': menuOpen }"
          />
        </div>
      </template>
    </lf-dropdown>
  </div>
</template>
<script setup lang="ts">
import { type PropType, computed } from "vue";
import { useStore } from "vuex";

import { prioritiesIconsMap } from "@/helpers/constants/communicationLogs";

import IconBase from "@/components/ui/IconBase.vue";
import LfDropdown, {
  type DropdownTeleportOptions,
} from "@/components/ui/inputs/LfDropdown.vue";

import type { TaskPriorityLevels } from "@/enums/communicationLogs";

defineEmits<{ change: [option: TaskPriorityLevels] }>();

defineProps({
  priorityLevel: {
    type: String as PropType<TaskPriorityLevels>,
    required: true,
  },
  name: {
    type: String,
    default: "priority_level",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showValue: {
    type: Boolean,
    default: true,
  },
  teleportOptions: {
    type: Object as PropType<Partial<DropdownTeleportOptions>>,
  },
  customZIndex: {
    type: String,
  },
});

const { getters } = useStore();

const priorityLevels = computed(() => {
  const taskPriorityLevels: TaskPriorityLevels[] =
    getters["options/taskPriorityLevels"];
  return taskPriorityLevels.reduce(
    (
      acc: Record<TaskPriorityLevels, TaskPriorityLevels>,
      curr: TaskPriorityLevels
    ) => {
      acc[curr] = curr;
      return acc;
    },
    {} as Record<TaskPriorityLevels, TaskPriorityLevels>
  );
});
</script>
